<script>
/**
 * This is a transition helper
 * It will expand the element to the full height of the element
 * Ideal for Accordions or collapsible elements
 * @example <transition-expand><div v-if="condition"></div></transition-expand>
 */
export default {
  name: 'BaseTransitionExpand',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'expand',
    },
    speed: {
      type: String,
      default: 'normal',
      validator(value) {
        return ['fast', 'normal', 'slow'].includes(value);
      },
    },
  },
  render(createElement, context) {
    const data = {
      props: {
        name: 'expand',
        speed: 'normal',
      },
      on: {
        beforeEnter(el) {
          const speed = {
            fast: '0.1s',
            normal: '0.5s',
            slow: '0.8s',
          }[context.props.speed];

          el.style.transition = `all ${speed}`;
        },
        afterEnter(element) {
          // console.log('transition', 'afterEnter');
          element.style.height = 'auto';
          element.style.overflowY = 'auto';
        },
        enter(element) {
          // Let's measure the height of the element
          element.style.overflow = 'hidden';
          element.style.height = 'auto';
          const { height } = getComputedStyle(element);

          // Now we set the height to 0 to hide the element
          element.style.height = 0;

          // Force repaint to make sure the
          // animation is triggered correctly.
          // eslint-disable-next-line no-unused-expressions
          // getComputedStyle(element).height;

          requestAnimationFrame(() => {
            element.style.height = height;
          });
        },
        leave(element) {
          const { height } = getComputedStyle(element);
          element.style.height = height;
          element.style.overflow = 'hidden';

          // Force repaint to make sure the
          // animation is triggered correctly.
          // eslint-disable-next-line no-unused-expressions
          // getComputedStyle(element).height;

          requestAnimationFrame(() => {
            element.style.height = 0;
          });
        },
      },
    };

    return createElement('transition', data, context.children);
  },
};
</script>
<style scoped lang="scss">
* {
  will-change: height;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}
</style>
